import React, { FC } from 'react';
import styled from 'styled-components';

const FieldContainer = styled.div`
  display: flex;
  flex-direction: column;
  color: #FFF;
  font-size: 24px;
  text-align: center;
  align-items: center;
`;

const NumberContainer = styled.div`
  flex-shrink: 0;
  width: min(20vh, 20vw);
  height: min(20vh, 20vw);
  background: #484848;
  border-radius: 4px;
  color: #FFF;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  transition: all 1s;
  font-family: din;
  font-weight: 500;
  line-height: 60px;
  text-align: center;
  font-size: 50px;

  @media screen and (max-width: 400px) {
    width: 20wmin;
    height: 20vmin;
    font-size: 17.5vmin;
  }

  @media screen and (min-width: 400px) {
    max-height: 100px;
    max-width: 100px;
    font-size: 70px;
  }

  @media screen and (min-width: 1200px) {
    max-height: 110px;
    max-width: 110px;
    font-size: 75px;
  }

  @media screen and (min-width: 1440px) {
    max-height: 124px;
    max-width: 124px;
    font-size: 80px;
  }
`;

const NumberDeleteLine = styled.div`
  border: 3px solid #484848;
  position: absolute;
  width: 100%;
`;

const UnitContainer = styled.div`
  color: #FFF;
  display: block;
  margin-top: 8px;
  font-family: din;
  font-weight: 500;
  line-height: 24px;
  text-align: center;
  font-size: 14px;

  @media screen and (min-width: 350px) {
    font-size: 16px;
  }

  @media screen and (min-width: 450px) {
    font-size: 20px;
  }

  @media screen and (min-width: 960px) {
    font-size: 22px;
  }

  @media screen and (min-width: 1440px) {
    font-size: 24px;
  }
`;

const leftPadZero = (s) => `${s}`.padStart(2, '0');

export interface CountdownFieldProps {
  number: number;
  unit: string;
}

const CountdownField: FC<CountdownFieldProps> = ({ number, unit }: CountdownFieldProps) => (
  <FieldContainer>
    <NumberContainer>
      <NumberDeleteLine />
      {leftPadZero(number)}
    </NumberContainer>
    <UnitContainer>{unit}</UnitContainer>
  </FieldContainer>
);

export default React.memo(CountdownField);
